import { Model, ModelAttributes, model, modelConfig } from "@mixitone/oom";
import { setAccountId } from "./concerns/SetAccountId";
import { Database } from "./database.types";

const config = modelConfig(
  {
    account_id: {
      type: "string",
    },
    club_id: {
      type: "string",
    },
    created_at: {
      type: "datetime",
    },
    display_name_masked: {
      type: "string",
    },
    is_deleted: {
      type: "boolean",
    },
    last_connected_at: {
      type: "datetime",
    },
    last_error_at: {
      type: "datetime",
    },
    last_error_message: {
      type: "string",
    },
    payee_account_number: {
      type: "string",
    },
    payee_name: {
      type: "string",
    },
    payee_ready: {
      type: "boolean",
    },
    payee_verified_at: {
      type: "datetime",
    },
    source: {
      type: "enum",
      enumType: "oauth" as Database["public"]["Enums"]["club_akahu_connection_source"],
    },
    status: {
      type: "enum",
      enumType: "" as Database["public"]["Enums"]["club_akahu_connection_status"],
    },
    updated_at: {
      type: "datetime",
    },
  },
  {},
  {},
);

interface ClubAkahuConnection extends ModelAttributes<typeof config> {}

@setAccountId
@model("club_akahu_connections", config)
class ClubAkahuConnection extends Model<typeof config> {
  get isConnected(): boolean {
    return this.status === "connected" && this.payee_ready === true;
  }

  get isPayeeVerified(): boolean {
    return this.payee_verified_at != null;
  }
}

export default ClubAkahuConnection;
